import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { pt as locale } from 'date-fns/locale'

import services from '@/services'
import { useEffect, useState } from 'react'
import { SkeletonCard } from './skeleton-card'

interface Props {
  date: Date
}

export function Card({ date }: Props) {
  const queryFn = async () => await services.payments.getByDate(date)

  const { data, isLoading } = useQuery({
    queryKey: ['/fixed-bills', date.getMonth()],
    queryFn,
    refetchInterval: 1000 * 60 * 5,
  })

  const [total, setTotal] = useState<number>(0)

  useEffect(() => {
    if (data) {
      let _total = 0
      if (date)
        data.forEach((item) => {
          if (new Date(item.createdAt).getMonth() === date.getMonth())
            _total = Number(item.amount) + _total
        })
      else
        data.forEach((item) => {
          _total = Number(item.amount) + _total
        })

      setTotal(_total)
    }
  }, [data, date])

  if (!data || isLoading) return <SkeletonCard />

  return (
    <article className="bg-[#37393F] rounded-lg py-4 px-5 space-y-4">
      <header className="font-semibold flex gap-3 justify-between items-center">
        <h4 className="font-bold capitalize">
          {date ? format(date, 'MMMM', { locale }) : 'Total'}
        </h4>
        <span>MZN</span>
      </header>
      <div className="text-2xl font-extrabold">
        {new Intl.NumberFormat('pt-MZ', {
          style: 'currency',
          currency: 'MZN',
        })
          .format(total)
          .replace('MTn', '')}
      </div>
    </article>
  )
}
